import React from 'react'
import { GeneralLedger, SubLedger } from '../../../../helpers/models/Models';
import { useFormik } from 'formik';
import { putDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess } from '../../../../constants/Toast';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import NepaliInputBox from '../../../../constants/NepaliInputBox';
import { handleNepaliInputChange, handleSelectBox } from '../../../../helpers/handleChange';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import DefaultSelectInputBox from '../../../../constants/DefaultSelectBox';
import { LedgerTypeOptions, YesNoOptions } from '../../../../constants/Options';
import DialogBox from '../../../../constants/DialogBox';
// return results.results.map((item: SubLedger) => ({
//     sglsn: item.sglsn,
//     sub_ledg_id: item.sub_ledg_id,
//     diff_ac_on: item.diff_ac_on,
//     sub_ledg_name: item.sub_ledg_name,
//     sub_ledg_name_nep: item.sub_ledg_name_nep,
//     gl_type_cat: item.gl_type_cat === 1 ? "Assets" : item.gl_type_cat === 2 ? "Liabilities" : item.gl_type_cat === 3 ? "Income" : "Expenses",
//     show_det_modee: <StatusBadge status={item.show_det_mode} />,
//     show_det_mode: item.show_det_mode,
//     glid: item.glid,
//     active: item.status,
//     status: item.status,
//     branch_id: item.branch_id,
//     dep_rate: item.dep_rate,
//     mem_cate_id: item.mem_cate_id,
//     actions: (
//         <button onClick={() => handleEdit(item)}>Edit</button>
//     ),
// }));
interface SubLedgerEditViewProps {
    dialogOpen: boolean;
    currentItem: SubLedger | null;
    setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleFormSuccess: () => void;
}
const SubLedgerEditView: React.FC<SubLedgerEditViewProps> = ({ dialogOpen, handleFormSuccess, currentItem, setDialogOpen }) => {
    const initialValues = {
        sglsn: currentItem?.sglsn || "",
        sub_ledg_name: currentItem?.sub_ledg_name || "",
        sub_ledg_name_nep: currentItem?.sub_ledg_name_nep || "",
        show_det_mode: currentItem?.show_det_mode === 1 ? "1" : "2" || "",
        status: currentItem?.status === 1 ? "1" : "2" || "",
        mem_cate_id: currentItem?.mem_cate_id === 0 ? "2" : "1" || "",
        diff_ac_on: currentItem?.diff_ac_on === 1 ? "1" : "2" || "",
        gl_type_cat: currentItem?.gl_type_cat,
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: authorValidationSchema,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("sub_ledg_name", values.sub_ledg_name);
            formData.append("sub_ledg_name_nep", values.sub_ledg_name_nep);
            formData.append("show_det_mode", values.show_det_mode?.toString() === "2" ? "0" : "1");
            formData.append("status", values.status?.toString() === "1" ? "1" : "0");
            formData.append("mem_cate_id", values.mem_cate_id?.toString() === "1" ? "1" : "0");
            formData.append("diff_ac_on", values.diff_ac_on?.toString() === "2" ? "0" : "1");
            formData.append("gl_type_cat", values.gl_type_cat?.toString() ?? "");
            try {
                await putDataToTheServer(AppURL.AccountURL + "account/subledger/ledger/update/view/" + currentItem?.sglsn, formData).then((res) => {
                    if (res?.status === 200) {
                        ToastSuccess({ message: res?.message });
                        setDialogOpen(false)
                        handleFormSuccess();
                    }
                    action.resetForm();
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <DialogBox open={dialogOpen} headerName='Sub Ledger Edit' close={() => setDialogOpen(false)}>
            <form onSubmit={handleSubmit}>
                <Grid container columnSpacing={0.5} rowSpacing={0.5}>
                    <Grid item lg={4} md={4} xs={12} xl={4} sm={12}>
                        <InputTextBox
                            type='text'
                            label='Sub Ledger Name'
                            name='sub_ledg_name'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            error={errors.sub_ledg_name}
                            disabled={false}
                            value={values.sub_ledg_name}
                            placeholder='Enter Sub Ledger Name'
                            required={true}
                        />
                    </Grid>
                    <Grid item lg={4} md={4} xs={12} xl={4} sm={12}>
                        <NepaliInputBox
                            label="Sub Ledger Name(Nepali)"
                            name='sub_ledg_name_nep'
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'sub_ledg_name_nep' })}
                            value={values.sub_ledg_name_nep}
                            error={errors.sub_ledg_name_nep}
                            handleBlur={handleBlur}
                            touched={touched.sub_ledg_name_nep}
                            placeholder='Enter Sub Ledger Name(Nepali)'
                            required={true} />
                    </Grid>

                    <Grid item xl={4} lg={4} sm={12} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label="Different AC/ON"
                            options={YesNoOptions}
                            name='diff_ac_on'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select Different AC/ON'
                            value={values.diff_ac_on}
                            touched={touched.diff_ac_on}
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} sm={12} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label="Ledger Type"
                            options={LedgerTypeOptions}
                            name='gl_type_cat'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select GL Type'
                            value={values.gl_type_cat}
                            touched={touched.gl_type_cat}
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} sm={12} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label="Member List Show"
                            options={YesNoOptions}
                            name='mem_cate_id'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select Member List show'
                            value={values.mem_cate_id}
                            touched={touched.mem_cate_id}
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} sm={12} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label="Report Details Show"
                            options={YesNoOptions}
                            name='show_det_mode'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select status'
                            value={values.show_det_mode}
                            touched={touched.show_det_mode}
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} sm={12} md={4} xs={12}>
                        <DefaultSelectInputBox
                            label="Active"
                            options={YesNoOptions}
                            name='status'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select GL Status'
                            value={values.status}
                            touched={touched.status}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={20}>
                            <Button btn_type='update' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>
        </DialogBox>
    )
}

export default SubLedgerEditView